import * as React from "react";
import Box from "@mui/material/Box";
import Rating from "@mui/material/Rating";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

// dataListforRating Object definition
/**
 * @param {Object} params - The list of objects for the dataListObject.
 * @param {Object} params.object. - The object which contains the details regarding the each individual star.
 * @param {Number} params.object.score - The individual score for each star
 * @param {String} params.object.colorCode - The color for the individual star
 * @param {String} params.object.label - The individual label for each star which is to be displayed beside the star for user guidance
 */
export default function CloseFeedbackDetailsWithStar({ defaultValue, onSatisfactionChange, dataListforRating }) {
  const [value, setValue] = React.useState(defaultValue);
  const { i18n, t } = useTranslation();
  const [isStarSelected, setIsStarSelected] = React.useState(false);
  const [hover, setHover] = React.useState(-1);
  const [selectedValueFromDataList, setSelectedValueFromDataList] = React.useState(null);
  const labels = dataListforRating.map((ele,index)=>(ele.label));
  const colorCodes = dataListforRating.map((ele,index)=>(ele.colorCode));
  const valuesFromDataList = dataListforRating.map((ele,index)=>(ele.value));
  React.useEffect(() => {
    if (
      defaultValue != null &&
      defaultValue !== -1 &&
      typeof onSatisfactionChange === "function"
    ) {
      onSatisfactionChange(valuesFromDataList[defaultValue - 1] ?? defaultValue);
    }
    // Sync the visual default into the parent once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRatingChange = (event, newValue) => {
    //debugger;
    console.log(newValue);
    if(newValue === null){
      setValue(-1);
      setHover(-1);
      setSelectedValueFromDataList(null);
    }
    else{
      setValue(newValue);
      setSelectedValueFromDataList(valuesFromDataList[value-1]);
    }
    
    if (onSatisfactionChange) {
      setIsStarSelected(true);
      onSatisfactionChange(valuesFromDataList[newValue-1]);
    }
  };

  return (
    <Box
      sx={{
        "& > legend": { mt: 2 },
        display: "flex",
        alignItems: "center",
      }}
    >
      {/* <Typography variant="body2">
        {t('general.select.satisfactionReason.textForStar')}
      </Typography> */}
      <Rating
        name="simple-controlled"
        value={value}
        onChange={handleRatingChange}
        onChangeActive={(event, newHover) => {
          if(newHover === -1){
            setHover(-1);
          }
          else{
            console.log(newHover);
            setHover(newHover);
          }
          
        }}
        size="large"
        sx={{
          fontSize: "260%!important",

          justifyContent: "center",
          color: colorCodes[value-1],
          "& .MuiRating-iconHover": {
            color: colorCodes[hover-1],
          },
        }}
      />
      {(value!==-1 || hover !== -1) && <Box sx={{ ml: 2 }}>{labels[hover !== -1 ? hover-1 : value-1]}</Box>}
    </Box>
  );
}
